import {
    PALLET_STOCK_REPORT_REQUEST,
    PALLET_STOCK_REPORT_SUCCESS,
    PALLET_STOCK_REPORT_FAILURE,
    PALLET_STOCK_FILTER_REPORT_REQUEST,
    PALLET_STOCK_FILTER_REPORT_SUCCESS,
    PALLET_STOCK_FILTER_REPORT_FAILURE,
  } from "../types/pallet-stock-report-types";
  
  const initialState = {
    palletStockReport: {},
    palletStockFilterReport: {},
    loading: false,
    error: null,
  };
  
  const palletStockReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PALLET_STOCK_REPORT_REQUEST: 
      case PALLET_STOCK_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PALLET_STOCK_REPORT_SUCCESS: {
        return {
          ...state,
          palletStockReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PALLET_STOCK_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          palletStockFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PALLET_STOCK_REPORT_FAILURE, PALLET_STOCK_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default palletStockReportReducer;
  